import React from 'react'
import HomeAbout from '../container/HomeContainer/HomeAbout'
import HomeContact from '../container/HomeContainer/HomeContact'
import HomeServices from '../container/HomeContainer/HomeServices'
import Footer from '../footer/Footer'
import MainNavigation from '../nav/MainNavigation'
import SEO from '../SEO/SEO'
import Slider from '../slider/Slider'

function Home() {
    return (
        <>
            <SEO title="Dr Bupathi Gastro and Laparoscopy || Home" />
            <MainNavigation />
            <Slider />
            <HomeAbout />
            <HomeServices />
            <HomeContact />
            <Footer />
        </>
    )
}

export default Home